import LangEnum from '../../../../../../lang/LangEnum';
import {
  InactivityBlockConfigKeys,
  InactivityBlockConfigLabels,
} from '../OrderInactivitySectionGeneralSettings.types';

export const REFERENCE_DATE_ITEMS = [
  {
    label: LangEnum.GENERAL_SETTINGS_ORDER_INACTIVITY_CREATED_AT,
    value: 'created_at',
    description: LangEnum.GENERAL_SETTINGS_ORDER_INACTIVITY_CREATED_AT_DESCRIPTION,
  },
  {
    label: LangEnum.GENERAL_SETTINGS_ORDER_INACTIVITY_UPDATED_AT,
    value: 'updated_at',
    description: LangEnum.GENERAL_SETTINGS_ORDER_INACTIVITY_UPDATED_AT_DESCRIPTION,
  },
];

export const INACTIVITY_CONFIGS: Array<{
  keys: InactivityBlockConfigKeys;
  labels: InactivityBlockConfigLabels;
}> = [
  {
    keys: {
      selectName: 'abandonOrderByPreOrderDate',
      timeoutName: 'abandonedOrderPreOrderTimeout',
    },
    labels: {
      selectLabel: LangEnum.GENERAL_SETTINGS_ORDER_INACTIVITY_REFERENCE_DATE_PRE_ORDER,
      inputLabel: LangEnum.GENERAL_SETTINGS_ORDER_INACTIVITY_DISABLE_PRE_ORDER_AFTER,
    },
  },
  {
    keys: {
      selectName: 'abandonOrderByFutureStockDate',
      timeoutName: 'abandonedOrderFutureStockTimeout',
    },
    labels: {
      selectLabel: LangEnum.GENERAL_SETTINGS_ORDER_INACTIVITY_REFERENCE_DATE_FUTURE_STOCK,
      inputLabel: LangEnum.GENERAL_SETTINGS_ORDER_INACTIVITY_DISABLE_FUTURE_STOCK_AFTER,
    },
  },
  {
    keys: { selectName: 'abandonOrderByDate', timeoutName: 'abandonedOrderTimeout' },
    labels: {
      selectLabel: LangEnum.GENERAL_SETTINGS_ORDER_INACTIVITY_REFERENCE_DATE_READY_FOR_DELIVERY,
      inputLabel: LangEnum.GENERAL_SETTINGS_ORDER_INACTIVITY_DISABLE_READY_FOR_DELIVERY_AFTER,
    },
  },
];
